import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { ViewGridFilterControlsEditor } from "./ViewGridFilterControlsEditor";

describe("ViewGridFilterControlsEditor", () => {
  it("adds a field filter and edits its label, options and default", () => {
    const onChange = jest.fn();
    const { rerender } = render(
      <ViewGridFilterControlsEditor
        controls={[]}
        fields={[{ key: "department", label: "Department" }]}
        onChange={onChange}
      />,
    );

    fireEvent.click(screen.getByRole("button", { name: "Add field filter" }));
    expect(onChange).toHaveBeenCalledWith([
      expect.objectContaining({
        field: "department",
        label: "Department",
        operator: "eq",
        option_source: "static",
      }),
    ]);
    const control = onChange.mock.calls.at(-1)?.[0][0];
    rerender(
      <ViewGridFilterControlsEditor
        controls={[control]}
        fields={[{ key: "department", label: "Department" }]}
        onChange={onChange}
      />,
    );
    fireEvent.change(screen.getByLabelText("Filter label"), {
      target: { value: "Team" },
    });
    expect(onChange.mock.calls.at(-1)?.[0][0].label).toBe("Team");
    fireEvent.click(screen.getByRole("button", { name: "Add option" }));
    expect(onChange.mock.calls.at(-1)?.[0][0].options).toHaveLength(2);
  });
});
